import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NtpServersApiService {

  private readonly ntpServersUrl: string = 'ntpServer';

  constructor(private http: HttpClient) {
  }

  public getNTPServers(): Observable<any> {
    return this.http.get(this.ntpServersUrl);
  }

  public getNTPServer(ntpServersId): Observable<any> {
    return this.http.get(`${this.ntpServersUrl}/${ntpServersId}`);
  }

  public editNTPServer(nTPServer, nTPServerId): Observable<any> {
    return this.http.put(`${this.ntpServersUrl}/${nTPServerId}`, nTPServer);
  }

  public addNTPServer(nTPServer): Observable<any> {
    return this.http.post(this.ntpServersUrl, nTPServer);
  }

  public deleteNTPServer(nTPServerId): Observable<any> {
    return this.http.delete(`${this.ntpServersUrl}/${nTPServerId}`);
  }
}

